import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Input,
  Label,
  InputGroup,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  DataTable,
  TableRowField,
  ExportCSV,
  MainLoader,
} from "../../../../components";
import {
  getUsers,
  deleteUser,
  resetUsers,
} from "../../../../store/user/actions";
import Select from "react-select";
import { getStores, resetStores } from "../../../../store/store/actions";
import { selectStoresForSelect } from "../../../../store/store/selector";
import { messages, layout } from "../../../../common/constants";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import MediaQuery from "react-responsive";
import { formatHelper } from "../../../../common/helpers";
import { getAll as allUsersExport } from "../../../../service/user";
import { exportExcel } from "./excel";

class UserList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      filter: "",
      selectedStore: null,
      loadingExport: false,
    };
    this.handleObtainUsersExport = this.handleObtainUsersExport.bind(this);

    this.handleStoreChange = this.handleStoreChange.bind(this);
    this.handleInputFilterChange = this.handleInputFilterChange.bind(this);
    this.optionsFormatterColumn = this.optionsFormatterColumn.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  async componentDidMount() {
    await this.props.getStores({ reset: true });
    await this.performGetUsers(true);
  }
  componentWillUnmount() {
    this.props.resetUsers();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      this.setState({ selectedStore: this.props.stores[0] });
    }

    this.checkUserDelete(prevProps);
  }

  async checkUserDelete(prevProps) {
    if (prevProps.deletedUser == null && this.props.deletedUser != null) {
      toast.success("Usuario eliminado satisfactoriamente");
      await this.setState({ page: 1 });
      this.performGetUsers();
    } else if (
      prevProps.deleteError == null &&
      this.props.deleteError != null
    ) {
      toast.error(this.props.deleteError);
    }
  }

  performGetUsers(reset = false) {
    const { stores, getUsers } = this.props;
    const { page, filter, selectedStore } = this.state;

    if (stores.length == 0) return;

    var storeId = 0;
    if (selectedStore) storeId = selectedStore.value;

    getUsers({ page, filter, storeId, reset });
  }

  async handlePageChange(page) {
    await this.setState({ page: page });
    this.performGetUsers();
  }

  async handleStoreChange(value) {
    if (value == this.state.selectedStore) return;
    await this.setState({ selectedStore: value, page: 1 });
    this.performGetUsers();
  }

  async handleInputFilterChange(e) {
    if (e.key === "Enter") {
      await this.setState({ page: 1 });
      this.performGetUsers();
    }
  }

  optionsFormatterColumn(cell, row) {
    return (
      <UncontrolledButtonDropdown>
        <DropdownToggle size="sm" color="primary">
          <i className="fa fa-bars"></i>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem
            onClick={() =>
              this.props.history.push(`/administration/users/${row.id}/detail`)
            }
          >
            <i className="fa fa-eye mr-1"></i> Detalle
          </DropdownItem>
          <DropdownItem
            onClick={() =>
              this.props.history.push(`/administration/users/${row.id}/edit`)
            }
          >
            <i className="fa fa-edit mr-1"></i> Editar
          </DropdownItem>
          <DropdownItem
            disabled={this.props.deleteLoading}
            onClick={() => this.performDeleteUser(row.id)}
          >
            <i className="fa fa-trash mr-1"></i> Eliminar
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    );
  }

  performDeleteUser(id) {
    Swal({
      title: "Eliminar usuario",
      text: "¿Estás seguro que deseas eliminar el usuario?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.value) {
        this.props.deleteUser(id);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  renderDataTable(columns) {
    return (
      <DataTable
        data={this.props.users}
        keyField="id"
        columns={columns}
        page={this.state.page}
        totalSize={this.props.total}
        sizePerPage={this.props.pageSize}
        loading={this.props.loading}
        onPageChange={this.handlePageChange}
      />
    );
  }

  handleObtainUsersExport() {
    this.setState({ loadingExport: true });
    allUsersExport(0, null, this.state.selectedStore.value)
      .then((response) => {
        exportExcel(response.data.data, this.state.selectedStore);
      })
      .finally(() => this.setState({ loadingExport: false }));
  }

  render() {
    const columnOption = {
      dataField: "",
      text: "",
      isDummyField: true,
      formatter: this.optionsFormatterColumn,
      style: { width: "50px" },
      headerStyle: { width: "50px" },
    };

    const columnsXS = [
      {
        dataField: "xs",
        text: "Usuario",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="Nombre:" value={row.name} />
              <TableRowField label="DNI:" value={row.dni} />
              <TableRowField label="Email:" value={row.email} />
              <TableRowField label="Teléfono:" value={row.phone} />
            </div>
          );
        },
      },
      columnOption,
    ];

    const columnsSM = [
      {
        dataField: "xs",
        text: "Usuario",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="Nombre:" value={row.name} />
              <TableRowField label="DNI:" value={row.dni} />
            </div>
          );
        },
      },
      {
        dataField: "phone",
        text: "Teléfono",
        style: { width: "120px" },
        headerStyle: { width: "120px" },
      },
      {
        dataField: "email",
        text: "Email",
        style: { width: "180px" },
        headerStyle: { width: "180px" },
      },
      columnOption,
    ];

    const columnsMD = [
      {
        dataField: "name",
        text: "Nombre",
      },
      {
        dataField: "dni",
        text: "DNI",
      },
      {
        dataField: "email",
        text: "Email",
      },
      {
        dataField: "phone",
        text: "Teléfono",
      },
      columnOption,
    ];
    if (this.props.loading || this.props.loadingStores) {
      return <MainLoader />;
    }
    return (
      <div className="animated">
        <Card>
          <CardHeader>
            <i className="icon-people"></i>Usuarios
          </CardHeader>
          <CardBody>
            <MediaQuery minDeviceWidth={760}>
              {(matches) => {
                if (matches) {
                  return (
                    <Row className="mb-2">
                      <Col sm="4">
                        <InputGroup>
                          <Input
                            type="text"
                            id="input1-group2"
                            name="input1-group2"
                            placeholder="Buscar"
                            value={this.state.filter}
                            onChange={(e) =>
                              this.setState({ filter: e.target.value })
                            }
                            onKeyPress={this.handleInputFilterChange}
                          />
                          <div className="input-group-prepend">
                            <Button
                              type="button"
                              color="primary"
                              onClick={() => this.performGetUsers()}
                            >
                              <i className="fa fa-search"></i>
                            </Button>
                          </div>
                        </InputGroup>
                      </Col>
                      <Col sm="5">
                        <Row>
                          <Col md="2">
                            <Label className="mt-2">Tienda:</Label>
                          </Col>
                          <Col md="10">
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              isLoading={this.props.loadingStores}
                              isSearchable={true}
                              noOptionsMessage={() => {
                                return messages.SELECT_NO_OPTIONS;
                              }}
                              placeholder=""
                              options={this.props.stores}
                              loadingMessage={() => {
                                return messages.SELECT_LOADING;
                              }}
                              onChange={this.handleStoreChange}
                              value={this.state.selectedStore}
                              isDisabled={this.props.loadingStores}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col sm="3">
                        <ExportCSV
                          disabled={this.state.loadingExport}
                          exportCSV={this.handleObtainUsersExport}
                          minWidth={760}
                        />
                      </Col>
                    </Row>
                  );
                } else {
                  return (
                    <Row className="mb-2">
                      <Col sm="12">
                        <InputGroup>
                          <Input
                            type="text"
                            id="input1-group2"
                            name="input1-group2"
                            placeholder="Buscar"
                            value={this.state.filter}
                            onChange={(e) =>
                              this.setState({ filter: e.target.value })
                            }
                            onKeyPress={this.handleInputFilterChange}
                          />
                          <div className="input-group-prepend">
                            <Button
                              type="button"
                              color="primary"
                              onClick={() => this.performGetUsers()}
                            >
                              <i className="fa fa-search"></i>
                            </Button>
                          </div>
                        </InputGroup>
                      </Col>
                      <Col sm="12">
                        <Row>
                          <Col md="12">
                            <Label className="mt-2">Tienda:</Label>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              isLoading={this.props.loadingStores}
                              isSearchable={true}
                              noOptionsMessage={() => {
                                return messages.SELECT_NO_OPTIONS;
                              }}
                              placeholder=""
                              options={this.props.stores}
                              loadingMessage={() => {
                                return messages.SELECT_LOADING;
                              }}
                              onChange={this.handleStoreChange}
                              value={this.state.selectedStore}
                              isDisabled={this.props.loadingStores}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="12">
                            <ExportCSV
                              disabled={this.state.loadingExport}
                              exportCSV={this.handleObtainUsersExport}
                              minWidth={800}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  );
                }
              }}
            </MediaQuery>
            <hr className="my-4" />
            <Row className="mb-2">
              <Col>
                <div className="float-right">
                  <Button
                    color="primary"
                    onClick={() =>
                      this.props.history.push("/administration/users/add")
                    }
                  >
                    <i className="fa fa-plus mr-1"></i> Nuevo
                  </Button>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                  {this.renderDataTable(columnsXS)}
                </MediaQuery>
                <MediaQuery
                  minWidth={layout.SM_MIN_WIDTH}
                  maxWidth={layout.MD_MAX_WIDTH}
                >
                  {this.renderDataTable(columnsSM)}
                </MediaQuery>
                <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                  {this.renderDataTable(columnsMD)}
                </MediaQuery>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, error, loading, pageSize, total } = state.user.userList;

  return {
    users,
    error,
    loading,
    pageSize,
    total,
    stores: selectStoresForSelect(state),
    loadingStores: state.store.storeList.loading,
    deletedUser: state.user.deleteUser.user,
    deleteError: state.user.deleteUser.error,
    deleteLoading: state.user.deleteUser.loading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getUsers,
      getStores,
      resetStores,
      resetUsers,
      deleteUser,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(UserList);



// WEBPACK FOOTER //
// ./src/scenes/Administration/User/UserList/UserList.js